export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#141414] bg-[#050505] py-14">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-8 px-6 md:flex-row md:px-12">
        <div className="flex items-center gap-3">
          <span className="grid h-8 w-8 place-items-center border border-[#d91616]/60 text-[#d91616]">
            <span className="font-jp text-lg leading-none">藤</span>
          </span>
          <span className="font-display text-xl font-extrabold tracking-tight">
            TOJI<span className="text-[#d91616]">.</span>
          </span>
        </div>

        <p className="font-body max-w-md text-center text-xs leading-relaxed text-white/35 md:text-left">
          Toji Peptides is an educational resource. All content is provided for
          informational and research purposes only — not medical advice, and not
          for human consumption.
        </p>

        <div className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-white/40">
          © {new Date().getFullYear()} Toji Peptides
        </div>
      </div>

      <div className="mt-12 flex justify-center">
        <span className="font-display text-2xl font-black tracking-[0.35em] text-white/25">
          XIII
        </span>
      </div>
    </footer>
  );
}
